export const emailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
export const feetInchRegex2 = /^(\d+)'(\d+)''$/;
export const feetInchRegex =
  /^(?!$|.*'[^\x22]+$)(?:([0-9]+)')?(?:([0-9]+)\x22?)?$/;
